import { render, staticRenderFns } from "./BlogBlockSelector.vue?vue&type=template&id=1f22ef56&"
import script from "./BlogBlockSelector.vue?vue&type=script&lang=js&"
export * from "./BlogBlockSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports